import { criancaFunc, vrCriancaFunc } from "../../helpers/Funcionalidades";


export const handleVerifyRedirectPendencia = (valuesProps, valuesPropsPencia, history, idCrianca, redirect, roleKeycloack, user, idPJ) => {

  let pagina;

  const idAba = valuesProps;
  const idTipoPendencia = valuesPropsPencia;

  const validAnexoAbas = new Set([1])
  const validDadosPrincipaisAbas = new Set([2]);
  const validDocumentacaoAbas = new Set([3]);
  const validEducacaoAbas = new Set([4]);
  const validHistoricoAbas = new Set([5]);
  const validProfissionalizacaoAbas = new Set([6]);
  const validApadrinhamentoAbas = new Set([7]);
  const validReferenciaAbas = new Set([8]);
  const validSaudeAbas = new Set([9]);
  const validSituacaoJuridicaAbas = new Set([10]);
  const validVisitaAbas = new Set([11]);

  const validDocumentacaoPendencias = new Set([9]);
  const validEducacaoPendencias = new Set([38]);
  const validProfissionalizacaoPendencias = new Set([40]);
  const validApadrinhamentoPendencias = new Set([53]);
  const validSaudePendencias = new Set([33]);

   const hasOrgao = (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
      roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
      user?.orgaoExterno?.includes(idPJ);

  const dadosPrincipaisPersmissaoEditar = roleKeycloack?.includes(criancaFunc.editar)
  const documentacaoPersmissaoEditar = roleKeycloack?.includes(vrCriancaFunc.documentacaoEditar)
  const apadrinhamentoPersmissaoEditar = roleKeycloack?.includes(criancaFunc.apadrinhamentoEditar)
  const saudePersmissaoEditar = roleKeycloack?.includes(criancaFunc.editarSaude)
  const profissionalizacaoPersmissaoEditar = roleKeycloack?.includes(criancaFunc.editarProfissionalizacao)
  const educacaoPersmissaoEditar = roleKeycloack?.includes(criancaFunc.alterarEducacao)


  if (validAnexoAbas.has(idAba)) {
    pagina = "/visualizar-anexos"
  } else if (validDadosPrincipaisAbas.has(idAba)) {
    if(!dadosPrincipaisPersmissaoEditar && !hasOrgao){
      pagina = ""
    }else{
      pagina = "/editar"
    }
   
  } else if (validDocumentacaoAbas.has(idAba)) {
    if (validDocumentacaoPendencias.has(idTipoPendencia)) {
      pagina = "/cadastrar-documentacao"
    } else {
      if(!documentacaoPersmissaoEditar && !hasOrgao){
        pagina = "/visualizar-documentacao"
      }else{
        pagina = "/editar-documentacao"
      }
    }
  } else if (validApadrinhamentoAbas.has(idAba)) {
    if (validApadrinhamentoPendencias.has(idTipoPendencia)) {
      pagina = "/visualizar-apadrinhamento"
    } else {
      if(!apadrinhamentoPersmissaoEditar && !hasOrgao){
        pagina = "/visualizar-documentacao"
      }else{
        pagina = "/editar-documentacao"
      }
      pagina = "/editar-apadrinhamento"
    }

  } else if (validSituacaoJuridicaAbas.has(idAba)) {
    pagina = "/visualizar-situacao-juridica"
  } else if (validHistoricoAbas.has(idAba)) {
    pagina = "/visualizar-movimentacao"
  } else if (validSaudeAbas.has(idAba)) {
    if (validSaudePendencias.has(idTipoPendencia)) {
      pagina = "/visualizar-saude"
    } else {
      if(!saudePersmissaoEditar && !hasOrgao){
        pagina = "/visualizar-saude"
      }else{
        pagina = "/editar-saude"
      }
      
    }

  } else if (validProfissionalizacaoAbas.has(idAba)) {
    if (validProfissionalizacaoPendencias.has(idTipoPendencia)) {
      pagina = "/visualizar-profissionalizacao"
    } else {
      if(!profissionalizacaoPersmissaoEditar && !hasOrgao){
        pagina = "/visualizar-profissionalizacao"
      }else{
        pagina = "/editar-profissionalizacao"
      }

      
    }

  } else if (validVisitaAbas.has(idAba)) {
    pagina = "/visualizar-visitas"
  } else if (validReferenciaAbas.has(idAba)) {
    pagina = "/visualizar-referencia-familiar"
  } else if (validEducacaoAbas.has(idAba)) {
    if (validEducacaoPendencias.has(idTipoPendencia)) {
      pagina = "/visualizar-educacao"
    } else {
      if(!educacaoPersmissaoEditar && !hasOrgao){
        pagina = "/visualizar-educacao"
      }else{
        pagina = "/editar-educacao"
      }

      
    }
  }

  if (typeof pagina === "string") {
    if (redirect) {
      history.push(`/crianca${pagina}/${idCrianca}?idAba=${idAba}&idTipoPendencia=${idTipoPendencia}`);
    }
    return true;
  }
  return false;
};